const entityColor = {
  admin: "blue",
  email: "blue",
  library: "blue",
  location: "blue",
  organization: "blue",
  report: "blue",
  ticket: "blue",
  user: "blue",
  api: "blue",
  general: "blue",
  engagement: "blue",
  role: "blue",
};

export default entityColor;
